"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ButtonBase2 = _interopRequireDefault(require("@mui/material/ButtonBase"));
var _OpenInNewOutlined2 = _interopRequireDefault(require("@mui/icons-material/OpenInNewOutlined"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _PublicOutlined2 = _interopRequireDefault(require("@mui/icons-material/PublicOutlined"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _react = _interopRequireDefault(require("react"));
var _challengeCard = require("../../challenge-card");
var _info = _interopRequireDefault(require("./info"));
var _leaderboard = _interopRequireDefault(require("./leaderboard"));
var _progression = _interopRequireDefault(require("./progression"));
var _sponsors = _interopRequireDefault(require("./sponsors"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function Home({
  Button,
  Dialog,
  ownGeogroup,
  event,
  defaultParticipationGroup,
  onOwnCompanyClick,
  selectTab,
  selectLeaderboardSize,
  displayLeaderboard
}) {
  return /*#__PURE__*/_react.default.createElement(_Box2.default, {
    paddingY: 3,
    sx: {
      containerType: 'inline-size'
    }
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: {
      '@': 'column',
      '@800': 'row'
    },
    gap: 3
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    gap: 2,
    width: {
      '@': '100%',
      '@800': 'calc(100% - 344px)'
    }
  }, /*#__PURE__*/_react.default.createElement(_progression.default, {
    event: event
  }), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    bgcolor: "#fff",
    borderRadius: 4,
    padding: 3
  }, /*#__PURE__*/_react.default.createElement(_challengeCard.ChallengeCardData, {
    enableCollaborationType: true,
    enableProgressionHighlight: true,
    Button: Button,
    challenge: event.challengeTemplate || undefined,
    Dialog: Dialog,
    event: event,
    geogroup: ownGeogroup,
    onFAQClick: () => selectTab('faq'),
    userChallenge: null
  })), /*#__PURE__*/_react.default.createElement(_info.default, null)), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    flexShrink: 0,
    gap: 2,
    width: {
      '@': '100%',
      '@800': 320
    }
  }, /*#__PURE__*/_react.default.createElement(_sponsors.default, {
    defaultParticipationGroup: defaultParticipationGroup
  }), event.detailsUrl && /*#__PURE__*/_react.default.createElement(_ButtonBase2.default, {
    component: "a",
    href: event.detailsUrl,
    sx: {
      alignItems: 'center',
      bgcolor: '#fff',
      borderRadius: 4,
      flexDirection: 'row',
      gap: 2,
      padding: 3
    },
    target: "_blank"
  }, /*#__PURE__*/_react.default.createElement(_PublicOutlined2.default, {
    color: "primary",
    style: {
      flexShrink: 0
    }
  }), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    overflow: "hidden"
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    overflow: "hidden",
    textOverflow: "ellipsis",
    variant: "body2",
    whiteSpace: "nowrap"
  }, event.detailsUrl.replace('https://', '').replace('http://', ''))), /*#__PURE__*/_react.default.createElement(_OpenInNewOutlined2.default, {
    color: "action",
    fontSize: "small",
    style: {
      flexShrink: 0
    }
  })), /*#__PURE__*/_react.default.createElement(_leaderboard.default, {
    Button: Button,
    event: event,
    onOwnCompanyClick: onOwnCompanyClick,
    ownGeogroup: ownGeogroup,
    selectLeaderboardSize: size => {
      selectTab('companiesLeaderboard');
      selectLeaderboardSize(size);
      displayLeaderboard(true);
    }
  }))));
}
var _default = exports.default = Home;